import React from 'react';
import { StoreTypeEnum } from '@goparrot/store-v2-sdk';
import classNames from 'classnames';
import { IconCentralLocation } from '@goparrot-dashboard/shared-ui';

type NavBarStoreIconProps = {
  storeType: StoreTypeEnum;
  isCentralLocation: boolean;
};

const storeTypeStyle = 'tw-w-5 tw-inline-block tw-text-center tw-font-normal tw-mr-1.5 tw-rounded-sm tw-text-white';

const NavBarStoreIcon: React.FC<NavBarStoreIconProps> = ({ storeType, isCentralLocation }) => {
  return (
    <>
      {storeType === StoreTypeEnum.MERCHANT && <span className={classNames([storeTypeStyle, 'tw-bg-light-blue-400'])}>M</span>}
      {storeType === StoreTypeEnum.STORE && (
        <span className={isCentralLocation ? 'tw-flex tw-mr-1.5' : classNames([storeTypeStyle, 'tw-bg-green-400'])}>
          {isCentralLocation ? (
            <span className="tw-flex">
              <IconCentralLocation />
            </span>
          ) : (
            'S'
          )}
        </span>
      )}
      {storeType === StoreTypeEnum.DEFAULT && <span className={classNames([storeTypeStyle, 'tw-bg-blue-500'])}>D</span>}
    </>
  );
};

export default NavBarStoreIcon;
